import { ROUTES, getCaseRoute } from '@/config/routes';

interface Breadcrumb {
  label: string;
  path: string;
}

interface BreadcrumbConfig {
  homeLabel: string;
  caseLabelPrefix: string;
}

export const getBreadcrumbs = (
  pathname: string,
  selectedCase: string | null,
  config?: BreadcrumbConfig
): Breadcrumb[] => {
  const caseLabelPrefix = config?.caseLabelPrefix || 'Case';

  const breadcrumbs: Breadcrumb[] = [];

  // If on /cases page, show "MASTERCLASS"
  if (pathname === ROUTES.CASES) {
    breadcrumbs.push({ label: 'MASTERCLASS', path: ROUTES.CASES });
  }
  // If on a case page, show "MASTERCLASS" > "Case X"
  else if (pathname.startsWith('/case/') && selectedCase) {
    breadcrumbs.push({ label: 'MASTERCLASS', path: ROUTES.CASES });
    breadcrumbs.push({
      label: `${caseLabelPrefix} ${selectedCase}`,
      path: getCaseRoute(selectedCase),
    });
  } else if (pathname.startsWith(ROUTES.STATS.replace(':caseId', ''))) {
    breadcrumbs.push({ label: 'MASTERCLASS', path: ROUTES.CASES });
    breadcrumbs.push({
      label: 'Stats',
      path: ROUTES.STATS.replace(':caseId', ''),
    });
  }

  return breadcrumbs;
};
